import { createFileRoute } from '@tanstack/react-router';
import { HelpSupportPage } from '../components/legal/HelpSupportPage';

export const Route = createFileRoute('/help-support')({
  component: HelpSupportPage,
});
